/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { goodLuckCoreDTOsReplayLaneMatchupDtoSchema } from "./replayLaneMatchupDtoSchema.ts";
import { goodLuckCoreDTOsReplayMatchMvpDtoSchema } from "./replayMatchMvpDtoSchema.ts";
import { goodLuckCoreDTOsReplayTeamNarrativeDtoSchema } from "./replayTeamNarrativeDtoSchema.ts";
import { z } from "zod/v4";

export const goodLuckCoreDTOsReplayMatchNarrativeDtoSchema = z.object({
  get teams() {
    return z.array(goodLuckCoreDTOsReplayTeamNarrativeDtoSchema).nullish();
  },
  get mvp() {
    return goodLuckCoreDTOsReplayMatchMvpDtoSchema.optional();
  },
  get laneMatchups() {
    return z.array(goodLuckCoreDTOsReplayLaneMatchupDtoSchema).nullish();
  },
});
